import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
    RPM_DELETE_CPT_LOG_BEGIN,
    RPM_DELETE_CPT_LOG_SUCCESS,
    RPM_DELETE_CPT_LOG_FAILURE,
    RPM_DELETE_CPT_LOG_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers'
import config from '../../../common/config'

export function deleteCptLog(args = {}) {
    return (dispatch, getState) => {
        // optionally you can have getState as the second argument
        dispatch({
            type: RPM_DELETE_CPT_LOG_BEGIN,
        })

        const promise = new Promise((resolve, reject) => {
            const doRequest = axios.delete(
                `${config.apiRootUrl}/rpm/cpt-log/${args.id}/`,
                createAxiosConfigWithAuth(getState())
            )
            doRequest.then(
                res => {
                    dispatch({
                        type: RPM_DELETE_CPT_LOG_SUCCESS,
                        data: res,
                    })
                    resolve(res)
                },
                // Use rejectHandler as the second argument so that render errors won't be caught.
                err => {
                    dispatch({
                        type: RPM_DELETE_CPT_LOG_FAILURE,
                        data: { error: err },
                    })
                    reject(err)
                }
            )
        })

        return promise
    }
}

export function dismissDeleteCptLogError() {
    return {
        type: RPM_DELETE_CPT_LOG_DISMISS_ERROR,
    }
}

export function useDeleteCptLog() {
    const dispatch = useDispatch()

    const { deleteCptLogPending, deleteCptLogError } = useSelector(
        state => ({
            deleteCptLogPending: state.rpm.deleteCptLogPending,
            deleteCptLogError: state.rpm.deleteCptLogError,
        }),
        shallowEqual
    )

    const boundAction = useCallback(
        (...args) => {
            return dispatch(deleteCptLog(...args))
        },
        [dispatch]
    )

    const boundDismissError = useCallback(() => {
        return dispatch(dismissDeleteCptLogError())
    }, [dispatch])

    return {
        deleteCptLog: boundAction,
        deleteCptLogPending,
        deleteCptLogError,
        dismissDeleteCptLogError: boundDismissError,
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case RPM_DELETE_CPT_LOG_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                deleteCptLogPending: true,
                deleteCptLogError: null,
            }

        case RPM_DELETE_CPT_LOG_SUCCESS:
            // The request is success
            return {
                ...state,
                deleteCptLogPending: false,
                deleteCptLogError: null,
            }

        case RPM_DELETE_CPT_LOG_FAILURE:
            // The request is failed
            return {
                ...state,
                deleteCptLogPending: false,
                deleteCptLogError: action.data.error,
            }

        case RPM_DELETE_CPT_LOG_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                deleteCptLogError: null,
            }

        default:
            return state
    }
}
